<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectItemDepth" });
import { SelectSingle } from "../../../../selects/index.js";
import { ITEM_DEPTHS } from "../../config/item-depths.js";
export let key;
export let name = "select-item-depth";
export let label = "Item Depth";
export let placeholder = "";
export let isDisabled = false;
export let isRequired = false;
export let hint = "";
</script>

<SelectSingle
  bind:key
  {name}
  options={ITEM_DEPTHS}
  {label}
  {placeholder}
  {hint}
  {isDisabled}
  {isRequired}
/>